import gql from 'graphql-tag';

import searchResultsPageFragment from '../fragments/searchResultsPageFragment';

export const querySearchResultsPage = gql`
  query searchResultsPage(
    $q: String
    $name: String
    $nameLowercase: String
    $fileContentMD5: String
    $searchResultTypes: [SearchResultType!]
    $dokkioClusterIDs: [DokkioID]
    $dokkioLabelIDs: [DokkioID]
    $dokkioTagIDs: [DokkioID!]
    $dokkioTagRanges: [DokkioTagRangeInput!]
    $integrationIDs: [DokkioID!]
    $integrationItemKinds: [IntegrationItemKind!]
    $integrationItemTypes: [IntegrationItemType!]
    $parentIntegrationItemIDs: [IntegrationItemInput!]
    $webpageTypes: [WebpageType!]
    $conversationOrigins: [ConversationOrigin!]
    $isPending: Boolean
    $lastModifiedBys: [LastModifiedBy!]
    $orderBy: SearchResultOrderByType
    $orderByDirection: OrderByDirection
    $count: Int
    $neuralCount: Int
    $offset: Int
    $webClippingURL: String
    $creatorDokkioUserID: DokkioID
    $rowCreateMethod: RowCreateMethod
    $suggestedDokkioTagName: String
  ) {
    searchResultsPage(
      q: $q
      name: $name
      nameLowercase: $nameLowercase
      fileContentMD5: $fileContentMD5
      searchResultTypes: $searchResultTypes
      dokkioClusterIDs: $dokkioClusterIDs
      dokkioLabelIDs: $dokkioLabelIDs
      dokkioTagIDs: $dokkioTagIDs
      dokkioTagRanges: $dokkioTagRanges
      integrationIDs: $integrationIDs
      integrationItemKinds: $integrationItemKinds
      integrationItemTypes: $integrationItemTypes
      parentIntegrationItemIDs: $parentIntegrationItemIDs
      isPending: $isPending
      lastModifiedBys: $lastModifiedBys
      webpageTypes: $webpageTypes
      conversationOrigins: $conversationOrigins
      orderBy: $orderBy
      orderByDirection: $orderByDirection
      count: $count
      neuralCount: $neuralCount
      offset: $offset
      webClippingURL: $webClippingURL
      creatorDokkioUserID: $creatorDokkioUserID
      rowCreateMethod: $rowCreateMethod
      suggestedDokkioTagName: $suggestedDokkioTagName
    ) {
      ...searchResultsPageFragment
    }
  }
  ${searchResultsPageFragment}
`;

export default querySearchResultsPage;
